module.exports = __webpack_public_path__ + "img/aipay.bf0f4d11.png";